export enum PrivacyFlag {
    SI = 'CONCESSA',
    NO = 'NON CONCESSA',
}
